import InfoIcon from '@mui/icons-material/Info';
import Button, { ButtonWrapper } from 'blocks/Button';
import { Text } from 'blocks/Text';
import Modal from 'components/Modal';
import { ModalFC } from 'config/types';
import { useTranslation } from 'react-i18next';
import { ModalEnterReasonParamModel } from './modalReject.interface';
import * as S from './modalReject.styles';
const ModalInformation: ModalFC<ModalEnterReasonParamModel> = ({ open, onClose, text }) => {
  const { t } = useTranslation();
  const handleClose = () => {
    onClose && onClose();
  };
  const handleInformation = () => {
    localStorage.setItem('informationuser', 'true');
    onClose && onClose();
  };

  return (
    <Modal open={open} onClose={handleClose} width="364px">
      <S.Wrapper>
        <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <InfoIcon style={{ color: '#588AF0', fontSize: '60px', marginBottom: '1rem' }} />

          <Text>{t('pages.dashboard.sections.InformationModal.text')}</Text>
        </div>

        <S.Buttons as={ButtonWrapper} justify="center" topSpace="medium">
          <S.Button as={Button} color="info" width={90} onClick={handleInformation}>
            {t('pages.dashboard.sections.InformationModal.btn')}
          </S.Button>
        </S.Buttons>
      </S.Wrapper>
    </Modal>
  );
};

export default ModalInformation;
